import { useContext } from "react";
import { ContextualSidebarContext } from "@context"
import MenuRouter from "@components/Menus/EventMenu/MenuRouter"

function useEventMenu(user, event) {
  const { setContextualSidebar } = useContext(ContextualSidebarContext);

  const open = (view) => {
    setContextualSidebar(prev => ({
      ...prev,
      open: true,
      title: "Event Settings",
      subTitle: "Manage your event settings and configurations.",
      content: <MenuRouter eventId={event.id} initialView={view} user={user} />,
      size: "lg",
    }));
  };

  const close = () => {
    setContextualSidebar(prev => ({
      ...prev,
      open: false,
    }));
  };

  return { open, close }
}

export default useEventMenu